export type LocationToolsMode = "linkTypes" | "byLocation" | "addLocation";

export const MODE_OPTIONS: { value: LocationToolsMode; label: string }[] = [
  { value: "linkTypes", label: "Edit link types" },
  { value: "byLocation", label: "Edit links by location" },
  // Slice 14: relabeled from "Add a new location" — the panel now mounts
  // the full OrgLocationsSection (add / edit / list / paginate), not
  // just a one-field create form. Mode id stays `addLocation` for
  // backwards-compat with persisted UI state in localStorage.
  { value: "addLocation", label: "Manage locations" },
];

export const adminGridBtn =
  "rounded-xl border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-900 p-4 text-left hover:bg-gray-50 dark:hover:bg-gray-800 transition shadow-sm min-h-[5.5rem] flex flex-col justify-between";
